import {saveAs} from 'file-saver'
import { convertSegmentsToSubtitles, createSubtitlesFromSegments } from './subtitleUtil'
import { getExportFilename, exportFile } from '../utils/common'

function _getExportFilename(title, ext) {
  return `${title.replace('.mp3', '').replace('.wav', '')}--edited.${ext}`;
}

function combineSubtitlesToFullSrt(subtitles) {
  let fullSrt = "";
  let index = 1;
  for (let subtitle of subtitles) {
    fullSrt += index++;
    fullSrt += "\r\n";
    fullSrt += subtitle.getSrtSubtitle();
    fullSrt += "\r\n\r\n"
  }
  return fullSrt;
}

function combineSubtitlesToFullVtt(subtitles) {
  let fullVtt = "WEBVTT";
  fullVtt += "\r\n\r\n"
  for (let subtitle of subtitles) {
    fullVtt += subtitle.getVttSubtitle();
    fullVtt += "\r\n\r\n"
  }
  return fullVtt;
}

export function exportSrt(transcript, fileName) {
  const subtitles = createSubtitlesFromSegments(transcript.segments);
  const srtContent = subtitles.toSrt();
  const filename = getExportFilename(fileName, 'srt');
  exportFile(filename, srtContent);
}

export function exportVtt(transcript, fileName) {
  const subtitles = createSubtitlesFromSegments(transcript.segments);
  const vttContent = subtitles.toVtt();
  const filename = getExportFilename(fileName, 'vtt');
  exportFile(filename, vttContent);
}